// v193 — Artifact dependency-graph API client (item 17 of
// docs/PRODUCT-ROADMAP.md, "Dependency-Graph für Artifacts").
//
// One read endpoint:
//   GET /api/v1/artifact-deps/{id}?depth=N
//
// Returns a depth-bounded JSON tree rooted at the supplied artifact.
// Each node carries:
//   - coord:        the canonical wire identifier (Maven g:a:v, npm name@v)
//   - kind:         dependency scope (compile/runtime/test/dev/peer/...)
//   - in_registry:  whether the dependency was resolved to a sibling
//                   artifact in the same repo (resolved → green node,
//                   unresolved → grey leaf)
//   - truncated:    set on a node that closed a cycle in the walk

import useSWR from 'swr';

export interface DepNode {
  id?: string;
  coord: string;
  kind?: string;
  in_registry: boolean;
  truncated?: boolean;
  children?: DepNode[];
}

const json = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

export function useArtifactDeps(artifactId?: string, depth: number = 3) {
  const url =
    artifactId
      ? `/api/v1/artifact-deps/${encodeURIComponent(artifactId)}?depth=${depth}`
      : null;
  return useSWR<DepNode>(url, json);
}
